<template>
  <sui-form-field :width="field.width || width || 16" :required="field.required" :error="isInvalid" v-if="field && !field.hidden">
    <label v-show="field.label">
      {{field.label}}
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="field.warning" v-if="field.warning"><i class="warning sign yellow fitted icon" /></span>
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="tooltip" v-if="tooltip"><i class="help circle blue fitted icon" /></span>
    </label>
    <textarea v-model.trim="$attrs.value" :icon="icon" :placeholder="fieldPlaceholder" :required="field.required" :rows="rows" @input="onInput" />
    <small v-if="description">
      {{description}}
    </small>
    <small class="errors">
      {{error}}
    </small>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'
  export default {
    name: 'FormEntityText',
    mixins: [
      FormField,
    ],
    props: {
      description: {
        type: String,
        required: false,
        default: '',
      },
    },
    computed: {
      rows() {
        const lines = this.$attrs.value.trim().split('\n')
        let rows = lines.length + 1
        lines.forEach(line => {
          rows += Math.floor(line.length / 90)
        })
        return rows
      },
    },
  }
</script>

<style scoped>
  .tooltip { float: right; }
  .errors { display: none; color: #9f3a38; }
  .error > .errors { display: block; }
</style>
